import LayoutContainer from "@client/layout/Container/container";
import { type EntityRef } from "@client/types";
import * as React from "react";
import EntityContainer from "../container";

export type EntityContainerMapProps = EntityRef & {
  itemsIds: string[];
  style?: React.CSSProperties;
  viewonly?: boolean;
};

type Props = EntityContainerMapProps;

export default (props: Props) => (
  <LayoutContainer id={props.id} source={props.source} style={props.style} viewonly={props.viewonly}>
    {props.itemsIds.map((id) => (
      <EntityContainer key={id} id={id} source={props.source} viewonly={props.viewonly} />
    ))}
  </LayoutContainer>
);
